import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Breakpoint } from '@capital-access/firefly/components';
import { PortfolioManager } from '@capital-access/ownership/common';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-portfolio-managers',
  templateUrl: './portfolio-managers.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PortfolioManagersComponent {
  LOCALIZATION_SCOPE = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;

  @Input() portfolioManagers: PortfolioManager[] = [];
  @Input() openInDrawer = false;

  @Output() openPortfolioManagersDrawer = new EventEmitter();

  get mobile(): boolean {
    return window.innerWidth < Breakpoint.Sm;
  }

  openProfileManagersDrawer() {
    this.openPortfolioManagersDrawer.emit();
  }
}
